// translations/landing.ts
export const translations = {
    en: {
      'hero.promo': '✨ Try for free - 3 days trial, no credit card required, no auto-renewal ✨',
      'hero.promoMobile': '✨ 3 days free trial ✨',
      'hero.title': 'Online',
      'hero.titleHighlight': 'PDF to XRechnung',
      'hero.titleEnd': 'conversion',
      'hero.subtitle': 'Convert your existing invoices into compliant XRechnung files – no new invoicing software needed. Meet European & German requirements without changing your invoicing process.',
      'hero.convertNow': 'Convert Invoice Now',
      'hero.signIn': 'Sign In',
  
      'features.heading': 'E-Invoicing Solution',
      'features.headingHighlight': 'without system change',
      'features.subtitle': 'Stay compliant with German and EU e-invoicing requirements without changing your existing invoicing workflow',
      'features.ai.title': 'Minimal Effort',
      'features.ai.description': 'No need to switch to new software. Simply convert your existing PDF invoices to XRechnung format quickly and easily when needed.',
      'features.secure.title': 'Secure & Private',
      'features.secure.description': 'Your invoice data is processed securely and never stored on our servers. Our servers are located in Frankfurt, Germany.',
      'features.compliance.title': 'Full Compliance',
      'features.compliance.description': 'Meet all German and EU requirements for e-invoices/XRechnung.',
      'features.compatibility.title': 'Ready to Submit',
      'features.compatibility.description': 'The converted files meet all specifications required by government portals and can be submitted immediately.',
  
      'howItWorks.title': 'How It',
      'howItWorks.titleHighlight': 'Works',
      'howItWorks.steps': [
        {
          step: '1',
          title: 'Upload PDF',
          description: 'Start by uploading your existing PDF invoice'
        },
        {
          step: '2',
          title: 'Automatic Conversion',
          description: 'Our AI processes and converts to EN 16931 XML'
        },
        {
          step: '3',
          title: 'Fact Check',
          description: 'Compare the AI output with the original PDF'
        },
        {
          step: '4',
          title: 'Download XRechnung',
          description: 'Get your compliant XRechnung file instantly'
        }
      ],
  
      'cta.title': 'Stay Compliant & Keep Your Current System',
      'cta.subtitle': 'No expensive software overhaul needed. Simply convert your existing invoices to the required format and stay compliant with German e-invoicing regulations.',
      'cta.button': 'Get Started Now',
  
      'home.pageTitle': 'PDF to XRechnung Converter',
      'home.description': 'Convert PDF invoices to XRechnung and EN 16931 XML format instantly. Compliant with German and EU e-invoicing standards.',
  
      // --- Pricing Section ---
      'pricing.title': 'Pricing',
      'pricing.titleHighlight': 'Plans',
      'pricing.subtitle': 'Choose the plan that fits your needs.',
      'pricing.annually': 'Annually',
      'pricing.monthly': 'Monthly',
      'pricing.onetime': 'One-time',
      'pricing.onetimePrice': '€5',
      'pricing.onetimeSubtitle': 'Convert a single invoice. No subscription.',
      'pricing.onetimeFeature1': 'Convert 1 invoice',
      'pricing.onetimeFeature2': 'No subscription',
      'pricing.onetimeFeature3': 'No account required',
      'pricing.onetimeFeature4': 'Basic support',
      'pricing.onetimeCta': 'Convert now',
      'pricing.starter': 'Starter',
      'pricing.starterAnnualPrice': '€12.5/mo',
      'pricing.starterMonthlyPrice': '€20/mo',
      'pricing.starterAnnualNote': '€150 billed annually',
      'pricing.starterMonthlyNote': 'Billed annually',
      'pricing.starterSubtitle': 'For growing businesses',
      'pricing.starterFeature1': 'Unlimited invoice conversions',
      'pricing.starterFeature2': 'No bulk processing',
      'pricing.starterFeature3': 'Priority support',
      'pricing.starterFeature4': '',
      'pricing.starterCta': 'Start free trial',
      'pricing.mostPopular': 'MOST POPULAR',
      'pricing.moneyBackGuarantee': '100% money-back guarantee',
      'pricing.enterprise': 'Enterprise',
      'pricing.enterpriseAnnualPrice': '€20/mo',
      'pricing.enterpriseMonthlyPrice': '€30/mo',
      'pricing.enterpriseAnnualNote': '€240 billed annually',
      'pricing.enterpriseMonthlyNote': 'Billed monthly',
      'pricing.enterpriseSubtitle': 'For high volume & compliance',
      'pricing.enterpriseFeature1': 'Bulk invoice processing',
      'pricing.enterpriseFeature2': 'DPA & compliance',
      'pricing.enterpriseFeature3': 'Dedicated account manager',
      'pricing.enterpriseFeature4': 'Custom onboarding',
      'pricing.enterpriseCta': 'Contact us',
      'pricing.enterpriseContactNote': 'Includes DPA, custom integrations & more',
      'pricing.feature.invoices': 'Invoices per month',
      'pricing.feature.bulk': 'Bulk processing (up to 10 invoices)',
      'pricing.feature.moneyback': '100% money-back guarantee',
      'pricing.feature.enterpriseSupport': 'Enterprise support & DPA / GDPR',
      'pricing.feature.noSubscription': 'No subscription',
      'pricing.value.1invoice': '1',
      'pricing.value.unlimited': 'Unlimited',
      'pricing.value.no': 'Not included',
      'pricing.value.yes': 'Included',
    },
    de: {
      'hero.promo': '✨ Kostenlos testen - 3 Tage Testphase, keine Kreditkarte erforderlich, keine automatische Verlängerung ✨',
      'hero.promoMobile': '✨ 3 Tage kostenlos testen ✨',
      'hero.title': 'Online',
      'hero.titleHighlight': 'PDF in XRechnung',
      'hero.titleEnd': 'umwandeln',
      'hero.subtitle': 'Wandeln Sie Ihre bestehenden Rechnungen in 100% konforme XRechnung-Dateien um – keine neue Rechnungssoftware nötig. Erfüllen Sie deutsche B2G-Anforderungen ohne Änderung Ihres Rechnungsprozesses.',
      'hero.convertNow': 'Jetzt Rechnung umwandeln',
      'hero.signIn': 'Anmelden',
  
      'features.heading': 'E-Rechnungslösung',
      'features.headingHighlight': 'ohne Systemwechsel',
      'features.subtitle': 'Bleiben Sie konform mit deutschen und EU-E-Rechnungsanforderungen, ohne Ihren bestehenden Rechnungsworkflow zu ändern',
      'features.ai.title': 'Minimaler Aufwand',
      'features.ai.description': 'Kein Umstieg auf neue Software nötig. Konvertieren Sie einfach Ihre bestehenden PDF-Rechnungen bei Bedarf einfach und schnell ins XRechnung-Format.',
      'features.secure.title': 'Sicher & Privat',
      'features.secure.description': 'Ihre Rechnungsdaten werden sicher verarbeitet, sofort konvertiert und nicht auf unseren Servern gespeichert. Die Server befinden sich in Deutschland.',
      'features.compliance.title': 'Volle Konformität',
      'features.compliance.description': 'Erfüllen Sie alle deutschen und EU-Anforderungen an E-Rechnungen/XRechnungen.',
      'features.compatibility.title': 'Sofort einreichbar',
      'features.compatibility.description': 'Die konvertierten Dateien erfüllen alle Spezifikationen, die von Behördenportalen gefordert werden, und können sofort eingereicht werden.',
  
      'howItWorks.title': 'So',
      'howItWorks.titleHighlight': 'funktioniert\'s',
      'howItWorks.steps': [
        {
          step: '1',
          title: 'PDF hochladen',
          description: 'Laden Sie Ihre PDF-Rechnung hoch'
        },
        {
          step: '2',
          title: 'Automatische Extraktion',
          description: 'Wir extrahieren die Daten automatisch'
        },
        {
          step: '3',
          title: 'Überprüfen',
          description: 'Überprüfen und bearbeiten Sie die Daten bei Bedarf'
        },
        {
          step: '4',
          title: 'XML herunterladen',
          description: 'Erhalten Sie sofort Ihre konforme XML-Datei'
        }
      ],
  
      'cta.title': 'Behalten Sie Ihr aktuelles System & erfüllen Sie Compliance-Anforderungen',
      'cta.subtitle': 'Keine teure Softwareumstellung nötig. Konvertieren Sie einfach Ihre bestehenden Rechnungen in das erforderliche Format und bleiben Sie konform mit deutschen E-Rechnungsvorschriften.',
      'cta.button': 'Jetzt starten',
  
      'home.pageTitle': 'PDF zu XRechnung Konverter',
      'home.description': 'Konvertieren Sie PDF-Rechnungen sofort in XRechnung und EN 16931 XML-Format. Konform mit deutschen und EU-Standards für elektronische Rechnungen.',
  
      // --- Pricing Section ---
      'pricing.title': 'Preise',
      'pricing.titleHighlight': 'Pakete',
      'pricing.subtitle': 'Wählen Sie das passende Paket für Ihre Anforderungen.',
      'pricing.annually': 'Jährlich',
      'pricing.monthly': 'Monatlich',
      'pricing.onetime': 'Einmalig',
      'pricing.onetimePrice': '5€',
      'pricing.onetimeSubtitle': 'Eine Rechnung umwandeln. Kein Abo.',
      'pricing.onetimeFeature1': '1 Rechnung konvertieren',
      'pricing.onetimeFeature2': 'Kein Abo',
      'pricing.onetimeFeature3': 'Kein Account nötig',
      'pricing.onetimeFeature4': 'Basis-Support',
      'pricing.onetimeCta': 'Jetzt konvertieren',
      'pricing.starter': 'Starter',
      'pricing.starterAnnualPrice': '12,5€/Monat',
      'pricing.starterMonthlyPrice': '12,5€/Monat',
      'pricing.starterAnnualNote': '150€ jährlich abgerechnet',
      'pricing.starterMonthlyNote': 'Jährlich abgerechnet',
      'pricing.starterSubtitle': 'Für wachsende Unternehmen',
      'pricing.starterFeature1': 'Unbegrenzte Rechnungsumwandlungen',
      'pricing.starterFeature2': 'Keine Massenverarbeitung',
      'pricing.starterFeature3': 'Priorisierter Support',
      'pricing.starterFeature4': '',
      'pricing.starterCta': 'Kostenlos testen',
      'pricing.mostPopular': 'BELIEBTES PAKET',
      'pricing.moneyBackGuarantee': '100% Geld-zurück-Garantie',
      'pricing.enterprise': 'Enterprise',
      'pricing.enterpriseAnnualPrice': '20€/Monat',
      'pricing.enterpriseMonthlyPrice': '30€/Monat',
      'pricing.enterpriseAnnualNote': '240€ jährlich abgerechnet',
      'pricing.enterpriseMonthlyNote': 'Monatlich abgerechnet',
      'pricing.enterpriseSubtitle': 'Für große Mengen & Compliance',
      'pricing.enterpriseFeature1': 'Massenverarbeitung von Rechnungen',
      'pricing.enterpriseFeature2': 'DPA & Compliance',
      'pricing.enterpriseFeature3': 'Persönlicher Ansprechpartner',
      'pricing.enterpriseFeature4': 'Individuelle Einführung',
      'pricing.enterpriseCta': 'Kontakt aufnehmen',
      'pricing.enterpriseContactNote': 'Inklusive DPA, Integrationen & mehr',
      'pricing.feature.invoices': 'Rechnungen pro Monat',
      'pricing.feature.bulk': 'Massenverarbeitung (bis zu 10 Rechnungen)',
      'pricing.feature.moneyback': '100% Geld-zurück-Garantie',
      'pricing.feature.enterpriseSupport': 'Enterprise-Support & DPA / DSGVO',
      'pricing.feature.noSubscription': 'Kein Abo',
      'pricing.value.1invoice': '1',
      'pricing.value.unlimited': 'Unbegrenzt',
      'pricing.value.no': 'Nicht enthalten',
      'pricing.value.yes': 'Enthalten',
    }
  };